import { Link } from '@zorro/design-system/v2/Link';
import { BlogIcon, HelpCenterIcon } from '@zorro/shared/assets';
import { Box, Group, Space, Text } from '@zorro/web/design-system';

export const NeedsHelp = () => {
  return (
    <Box>
      <Text fw={600} size="md">
        Need help?
      </Text>
      <Space h="md" />
      <Group gap="xs" wrap="nowrap">
        <HelpCenterIcon />
        <Link
          href="https://help.myzorro.co/en/collections/10222569-employers"
          prefetch={false}
          target="_blank"
          variant="primary"
        >
          Visit our help center
        </Link>
      </Group>
      <Group gap="xs" wrap="nowrap" mt="md">
        <BlogIcon />
        <Link
          href="https://myzorro.co/blog-lobby"
          prefetch={false}
          target="_blank"
          variant="primary"
        >
          See what’s new on our blog
        </Link>
      </Group>
    </Box>
  );
};
